const products = {
  "90s novelty horses loose fit women top": 999,
  "Airscape Short Sleeve Shirt": 1750,
  "Airsmyth Long Sleeve Shirt": 1750,
  "Balsam 5 Pocket Lean Pant": 1800,
  "Bandana Bucket Bag": 1500,
  "Belted V-Neck Jumpsuit": 1800,
  "Black Skin Fit Ankle Length Jeans": 1900,
  "Black Wash Slim Comfort Stretch Jeans": 3000,
  "Black Wash Straight Comfort Stretch Jeans": 1500,
  "Blue Bell Bottom 5 Pocket Jeans": 2100,
  "Blue Block Style Print Shirt": 1500,
  "Blue Checks Long Sleeve Shirt": 1750,
  "Blue Cord Dungaree": 2100,
  "Blue Cord Wide Jeans": 1900,
  "Blue Multi colour Lining Long Sleeve Tshirt": 1300,
  "Blue Strips High Rise Stripe Jeans": 2100,
  "Boat Neck Pink Lining Tshirt": 1300,
  "Boho Mushroom Patchwork Hoodie": 999,
  "Boot Cut Blue Jeans": 2100,
  "Broderie Sleeve Frill Neck Top": 999,
  "Brown Cord Dungaree Jeans": 2100,
  "Camel Cord Jeans": 2100,
  "Canvas Jewelry Bag": 1300,
  "Chain Dangle Earrings": 1200,
  "Chemise western embroidered Shirt": 1300,
  "Chunky Buckle Leather Belt": 600,
  "Chunky Buckle Suede Belt": 1500,
  "Comic All Over Printed Tshirt": 1900,
  "Connie Relaxed Silk Shirt": 999,
  "Cord Short Ankle Bell Bottom Jeans": 1900,
  "Cotton Striped Black Short Kurta": 1500,
  "Cotton V-Neck Long Sleeve Top": 1300,
  "Crazy Anime Oversize T-shirts": 1900,
  "Creekwater Flannel Shirt": 1750,
  "Creekwater True Navy Flannel Shirt": 1750,
  "Damask Abstract Print White Shirt": 1500,
  "Deep Wisteria Women’s Slim Leg Jeans": 2100,
  "Double Layer Scoop Long Sleeve": 1300,
  "Drawstring Faux Leather Clutch Bag": 1500,
  "Eden Broderie Blouse": 999,
  "Effie Smocked Top": 999,
  "Elis Long Sleeve Navy Blue Top": 999,
  "Eyelet Collared Column Midi Dress": 2000,
  "Evan Cashmere T-Shirt": 1300,
  "Faux Leather Crossbody Phone Bag": 800,
  "Faux Leather Small Tote Bag": 1400,
  "Faux Leather Tote Bag": 1500,
  "Flannagan Long Sleeve Shirt": 1750,
  "Fletcher Long Sleeve Shirt": 1750,
  "Floral Column Midi Dress": 1700,
  "Florida Texture Printed Black Oversized T-shirt": 1900,
  "Framer Long Sleeve Hoodie Tshirt": 1500,
  "Frill Detail Navy Blue Polka Top": 1300,
  "Garden Denim Tote Bag": 800,
  "Garden Tote Bag": 2000,
  "Gingham Big Check Blue Shirt": 1500,
  "Girlfriend Blue Denim Jeans": 1900,
  "Gray Wash Slim Comfort Stretch Jeans": 3500,
  "Green Mission Ridge Pant": 1700,
  "Green Moss Vintage Wash Pant": 1200,
  "Haircalf Mini Crossbody Bag with Chain Strap": 2000,
  "Half Sleeve Solid Colour Polo T shirt with Collar": 1900,
  "Hazel Checks Short Sleeve Shirt": 1750,
  "Indigo Rinse Straight Authentic Denim Jeans": 3500,
  "Indigo Wash Slim Comfort Stretch Jeans": 3500,
  "Indigo Wash Straight Comfort Stretch Jeans": 3000,
  "Isla Frill Detail Blouse": 999,
  "Jet Cord Pant Lean": 1600,
  "Lace Insert Shirt": 999,
  "Long Sleeve Breton": 999,
  "Medium Grey Wash Straight Comfort Stretch Jeans": 2500,
  "Medium Indigo Wash Slim Authentic Denim Jeans": 2000,
  "Medium Indigo Wash Slim Comfort Stretch Jeans": 2000,
  "Medium Indigo Wash Straight Authentic Denim Jeans": 3500,
  "Men Beige Cotton Banger Printed Tshirt": 1900,
  "Men Cotton Printed Black Short Kurta": 1500,
  "Men Khadi Cotton Printed Short Yellow Kurta": 1500,
  "Men’s Athletic Straight Khaki Pants – Flexible & Comfortable Fit": 1500,
  "Men’s Back Printed Los Angeles Oversized Black T-shirt": 1900,
  "Men’s Brown Trousers – Classic and Versatile": 2500,
  "Men’s Classic Chino Pants – Stylish & Comfortable Everyday Wear": 3000,
  "Men’s Local Pants – Relaxed Fit with Everyday Versatility": 1500,
  "Men’s Original Straight Khaki Pants – Comfortable and Versatile": 1600,
  "Men’s Relaxed Fit Ward Pants – Casual & Stylish Everyday Wear": 2400,
  "Men’s Slim-Fit Casual Pants – Modern Tailored Style": 2000,
  "Men’s Swifty Hoodie Tshirt": 1500,
  "Metal Loop Braided Wrap Belt": 200,
  "Metal Tipped Leather Belt": 600,
  "Midnight Bitterroot Henley Tshirt": 1500,
  "Mixed Stripe Scarf": 400,
  "Navy Blue Puffed Sleeve Tshirt": 1300,
  "Paisley Kimono – Free Size": 900,
  "Paisley Silk Little Scarf": 700,
  "Ponte Sweatshirt Mini Dress": 1400,
  "Quilted Drawstring Bucket Bag": 1000,
  "Ribbed Henley Sweater Dress": 2500,
  "Skinny Leather Wrap Belt": 300,
  "Skinny Mini Buckle Leather Belt": 700,
  "Sneezy Breezy Floral Print Blue Oversize Shirt": 1500,
  "Solid Shiny Solid Teal Shirt For Men": 1500,
  "Suede Tote Bag":700,
  "Toile Triangle Silk Scarf": 600,
  "Tropical Oversized Silk Scarf": 500,
  "Twine Ridge Pant": 1100,
  "Western Desert Cow Skull Leopard Cactus Top": 1400,
  "Women’s Handkerchief Hem Maxi Skirt": 800,
  "Women’s High-Rise Denim Skirt": 1100,
  "Women’s High-Rise Denim Mini Skirt – Classic Blue": 1600,
  "Women’s High-Rise Midi Denim Skirt": 1300,
  "Yellow Back Printed Oversized T shirts for Men": 1900
};


const orgDetails = {
  orgName: "",
  phoneNumber: "",
  orgAddress: "",
  gstNumber: "",
};

const shortName = "SG";

const vexora = { products, orgDetails, shortName };
export default vexora;
